import {IFormProps} from "../../../component/form/model/FormModel";
import BasicForm from "../../../component/form/BasicForm";
import ApiResponseVO from "../../../../ts/manager/api/ApiResonseVO";
import {getManager} from "../../../../ts/manager/Manager";
import TextAreaFIE from "../../../component/form/form-item-element/TextAreaFIE";
import AppButton from "../../../element/button/AppButton";
import React from "react";
import ApiError from "../../../../ts/manager/api/ApiError";
import {getModelFactory} from "../../../../ts/model-factory/ModelFactory";
import {
    AwardedToVO,
    PostActivityDataChoice,
    PostActivityDataModel
} from "../../../../ts/data/subject/PostActivityDataFactory";
import {PostConfig} from "../../../../ts/manager/post/PostManager";
import {PostDataChoice, PostDataModel} from "../../../../ts/data/subject/PostDataFactory";
import LoadingPartial from "../../../partial/status/LoadingPartial";
import moment from "moment";
import {formatPhoneNumber, isHTML, isNumeric, nl2br, phpToMomentDateFormat} from "../../../../ts/common/SiteHelper";
import Error404Partial from "../../../partial/status/Error404Partial";
import {PostListRouteModel} from "../../../../ts/route/subject/PostListRouteFactory";
import RouteChoiceButton from "../../../element/button/RouteChoiceButton";
import ToggleFIE from "../../../component/form/form-item-element/ToggleFIE";
import HTMLContentView from "../../../partial/content-blocks/HTMLContentView";
import {nbsp, wbsp} from "../../../../ts/common/Constants";

interface IProps extends IFormProps
{
    organisationID:number
    postType:"project"|"offer"
    postID:number
}

export default class ApplicationResponseForm extends BasicForm
{
    props: IProps;

    postDataModel: PostDataModel|null = null;
    postDataChoice: PostDataChoice|null = null;
    activityModel: PostActivityDataModel|null = null;
    organisationID: number = 0;
    existingEntry:PostActivityDataChoice|null = null;
    foundRequests:PostActivityDataChoice[] = [];
    postConfig:PostConfig
    organisationListRouteModel:PostListRouteModel|null = null;

    constructor(props: IProps)
    {
        super(props);

        this.props = props;
        this.postConfig = getManager().post.config[props.postType];
    }


    initVariables()
    {
        super.initVariables();

        this.organisationID = this.props.organisationID;

        this.postDataModel = getModelFactory().postData.getPostDataModel(this.postConfig.type, true);
        this.activityModel = this.organisationID ? getModelFactory().postActivityData.postActivityDataModel(this.organisationID) : null;
        this.organisationListRouteModel = getModelFactory().postListRoute.getDefaultModel("organisation");
    }

    async initModels(): Promise<void>
    {
        return this.requireModelPopulated().then((apiError) => {
            if(apiError){
                this.isInitializeInvalid = true;
            }
        });
    }

    async requireModelPopulated(): Promise<ApiError|null>
    {
        if(!this.activityModel || !this.postDataModel || !this.organisationListRouteModel){
            return null;
        }
        return this.postDataModel.requirePopulated().then((apiError) => {
            if (apiError)
            {
                return apiError;
            } else {
                this.postDataChoice = this.postDataModel?.choices[this.props.postID] ?? null;
                if(!this.postDataChoice){
                    return new ApiError(0, "", "Invalid post")
                }
                return this.organisationListRouteModel!.postDataModel!.requirePopulated().then((apiError) => {
                    if (apiError)
                    {
                        return apiError;
                    } else {

                        return this.activityModel!.requirePopulated().then((apiError) => {
                            if (apiError)
                            {
                                return apiError;
                            } else {
                                const foundOrganisationIDs:number[] = [];
                                let existingEntry:PostActivityDataChoice|null = null;
                                const foundRequests:PostActivityDataChoice[] = [];
                                for(let choice of this.activityModel!.choiceList()){
                                    if((choice.subjectPostID) === this.props.postID){
                                        if(choice.activityType === "apply"){
                                            if(foundOrganisationIDs.includes(choice.authorOrganisationID)){
                                                continue;
                                            }
                                            foundOrganisationIDs.push(choice.authorOrganisationID);
                                            foundRequests.push(choice);
                                        } else if((choice.activityType === "respond") && !existingEntry){
                                            existingEntry = choice
                                        }
                                    }
                                }
                                this.existingEntry = existingEntry;
                                this.foundRequests = foundRequests;
                                return null;
                            }
                        })
                    }
                })
            }

        })

    }

    async handleSubmitItems(formItemIDs: string[]|null, submitType: string): Promise<ApiResponseVO>
    {
        const params = this.collectParams(formItemIDs);
        const organisationAwardPrefix = "organisation_award_";
        const awardedOrganisationIDs:number[] = [];
        for(let key in params){
            if(key.startsWith(organisationAwardPrefix)){
                const organisationID = key.substring(organisationAwardPrefix.length);
                if(isNumeric(organisationID)){
                    const value = params[key];
                    if(value){
                        awardedOrganisationIDs.push(parseInt(organisationID));
                    }
                    delete params[key];
                }
            }
        }
        if(!awardedOrganisationIDs.length){
            const responseVO = new ApiResponseVO();
            responseVO.apiError = new ApiError(0, "", "You have not selected any organisations to award");
            return responseVO;
        }

        params.awarded_organisation_ids = awardedOrganisationIDs;
        params.reject_other_related = true;

        const responseVO =  await getManager().api.fetchData("/post/" + this.props.postType + "/" + this.props.postID + "/award_post/", "POST", params, true);
        if(responseVO.apiError){
            return responseVO;
        }
        this.activityModel?.resetPopulated();
        return this.requireModelPopulated().then((apiError:ApiError|null) =>{
            if(apiError){
                responseVO.apiError = new ApiError(404, "fatal_error", "Fatal Error");
            }
            return responseVO
        });
    }


    getIsClosed():boolean
    {
        return !this.postDataChoice || (this.postDataChoice.postStatus === "expired") || !this.postDataChoice.endsAt || (this.postDataChoice.endsAt.getTime() < (new Date()).getTime());
    }

    getAwardedTo():AwardedToVO[]{
        return this.existingEntry?.awardedTo ?? [];
    }

    isSubmitDisabled(): boolean
    {
        return super.isSubmitDisabled() || !this.getIsClosed();
    }


    renderComponent()
    {
        if(!this.modelsInitialized){
            return <LoadingPartial {...this.props.routeProps} />;
        }
        if(!this.postDataChoice){
            return <Error404Partial {...this.props.routeProps} />;
        }

        const isClosed = this.getIsClosed();
        const awardedTo = this.getAwardedTo();

        return <>
            <section className="content-block">

                <div className="container">

                    <div className="row">

                        <div className="col">


                            <h2>Review and award applications</h2>

                            {!this.foundRequests.length ? <>

                                {isClosed ? <>

                                    <p><strong>You did not receive any applications for this {this.postConfig.name}</strong></p>

                                    {!!this.postDataChoice.endsAt && <>
                                        <p>Applications are now closed.</p>
                                    </>}
                                </> : <>

                                    <p><strong>There have been no applicants to date</strong></p>

                                    {!!this.postDataChoice.endsAt && <>
                                        <p>You will be able to award the {this.postConfig.name} after applications close{wbsp}
                                            on {moment(this.postDataChoice.endsAt).format(phpToMomentDateFormat('j M Y'))} at {moment(this.postDataChoice.endsAt).format(phpToMomentDateFormat('g:ia'))}.</p>
                                    </>}
                                </>}
                            </> : <>
                                {isClosed ? <>
                                    {(!!awardedTo.length) ? <>
                                        <p>This {this.postConfig.name} was awarded by {this.existingEntry!.authorUserName}{wbsp}
                                            on {moment(this.existingEntry!.updatedDate).format(phpToMomentDateFormat('j M Y'))} at {moment(this.existingEntry!.updatedDate).format(phpToMomentDateFormat('g:ia'))}.</p>
                                        <p>You can review all applicants in the table below</p>
                                    </> : <>
                                        <p>You can review all applicants for this {this.postConfig.name} in the{wbsp}
                                            table below.</p>
                                        <p><strong>If you would like to make an award, you should select all{wbsp}
                                            applicants who will be awarded this {this.postConfig.name}, before{wbsp}
                                            agreeing to the terms and conditions below.</strong></p>
                                    </>}
                                </> : <>

                                    {!!this.postDataChoice.endsAt && <>
                                        <p><strong>In the table below is a list of current applicants. You will be{wbsp}
                                            able to award the {this.postConfig.name} after applications close{wbsp}
                                            on {moment(this.postDataChoice.endsAt).format(phpToMomentDateFormat('j M Y'))} at {moment(this.postDataChoice.endsAt).format(phpToMomentDateFormat('g:ia'))}.</strong>
                                        </p>
                                    </>}
                                </>}
                                <form
                                    onSubmit={this.handleFormSubmit}
                                    className={"award-form custom-form " +(this.isDisabled() ? "content-disabled" : "")}
                                >
                                    {this.startFormAlerts()}
                                    {this.requiredFieldsMessage()}

                                    <table className="clean-table w-100 ">

                                        <thead>

                                        <tr>

                                            <th>Date</th>
                                            <th>Organisation</th>
                                            <th>Additional Information</th>
                                            <th className="text-center">{!isClosed ? "Award?" : "Awarded?"}</th>

                                        </tr>

                                        </thead>

                                        <tbody>


                                        {this.foundRequests.map((request, index) =>
                                        {
                                            const organisationRouteChoice = this.organisationListRouteModel?.choices[request.authorOrganisationID] ?? null;

                                            let wasAwarded:boolean = false;
                                            for(let checkAgainst of awardedTo){
                                                if(checkAgainst.organisationID === request.authorOrganisationID){
                                                    wasAwarded = true;
                                                }
                                            }
                                            return <tr key={index} style={{verticalAlign: "top"}}>

                                                <td>{moment(request.createdDate).format(phpToMomentDateFormat('j M Y'))} at {moment(request.createdDate).format(phpToMomentDateFormat('g:ia'))}</td>

                                                <td>{organisationRouteChoice ? <RouteChoiceButton routeChoice={organisationRouteChoice} label={request.authorOrganisationTitle} /> : request.authorOrganisationTitle}</td>

                                                <td>
                                                    {!!request.furtherInformation && <HTMLContentView
                                                        dangerouslySetInnerHTML={{__html: request.getParagraphFurtherInformation()}}>
                                                    </HTMLContentView>}
                                                </td>

                                                <td className="text-center">
                                                    {!isClosed || !awardedTo.length ? <>

                                                        <ToggleFIE
                                                            form={this}
                                                            formItemProps={{
                                                                pointer: "organisation_award_"+request.authorOrganisationID,
                                                                name: "",
                                                                value: wasAwarded
                                                            }}
                                                            elementProps={{
                                                                alignment: "center"
                                                            }}
                                                        />
                                                    </> : <>
                                                        {wasAwarded ? "Y" : ""}
                                                    </>}
                                                </td>

                                            </tr>
                                        })}



                                        </tbody>



                                    </table>

                                    {(!isClosed || !awardedTo.length) ? <>
                                        <div className="form-element mt-5">
                                            <TextAreaFIE
                                                form={this}
                                                elementProps={{
                                                    maxlength: 1000
                                                }}
                                                formItemProps={{
                                                    pointer: "further_information",
                                                    name: "Would you like to provide feedback for your award choice?"
                                                }}
                                                instructions="Your feedback is both emailed to all
                                                        applicants, and is publicly visible on this site."
                                            />
                                        </div>
                                        <div className="form-element mt-5">

                                            <ToggleFIE
                                                form={this}
                                                formItemProps={{
                                                    pointer: "awarded_confirm",
                                                    name: "I understand and agree to all the site's terms and conditions.",
                                                    required: true
                                                }}
                                                instructions="Once a project or offer has been awarded, it cannot be reversed
                                                        on the site."
                                            />
                                        </div>
                                        <div className="form-element mt-5">

                                            {this.endFormAlerts()}
                                            <AppButton
                                                type="submit"
                                                loading={this.loading}
                                                className="btn reduced"
                                                disabled={this.isSubmitDisabled()}
                                            >
                                                Make Project Award
                                            </AppButton>
                                        </div>
                                    </> : <>
                                        <div className="form-element mt-5">
                                            <h3>Feedback Provided</h3>
                                            <div className="">
                                                {!!this.existingEntry?.furtherInformation && <HTMLContentView
                                                    className="wysiwyg-content"
                                                    dangerouslySetInnerHTML={{__html: this.existingEntry.getParagraphFurtherInformation()}}>
                                                </HTMLContentView>}
                                            </div>
                                        </div>
                                    </>}

                                </form>
                            </>}


                        </div>

                    </div>

                </div>
            </section>
        </>
    }
}